import React from 'react';
import Container from 'common/components/UI/Container';
import MediaPlaceholder from '../../Custom/MediaPlaceholder';
import ScreenImage from '../../Custom/ScreenImage';
import { BILLING_SCREENSHOT } from 'common/data/launch';

import { Wrapper, Intro, Shot, Frame } from './info.style';

const SHOT_SIZES =
  '(min-width: 1220px) 1110px, (min-width: 992px) 910px, (min-width: 768px) 690px, calc(100vw - 60px)';

const BILLING_ALT =
  'CloudPouch Billing view for the ACME-prod profile: the services cost table with the usage cost of each service, a Region filter and a service opened to its usage types.';

// BILLING_SCREENSHOT (common/data/launch.js) switches the placeholder to the
// real CloudPouch 2.0 Billing screenshot.
const InfoSection = () => (
  <Wrapper id="service_costs">
    <Container>
      <Intro>
        <span>BILLING</span>
        <h2>See service costs. Drill down to usage type.</h2>
        <p>
          The Billing view groups your AWS spend by service. Open a service to
          see what its cost is made of, down to the usage type, and
          “EC2 - Other” stops being a mystery.
        </p>
        <p>
          Filter the table by Region, and pick a period on the chart to see how
          each service changed against the previous one.
        </p>
      </Intro>
      <Shot>
        {BILLING_SCREENSHOT ? (
          <ScreenImage
            name={BILLING_SCREENSHOT.name}
            alt={BILLING_ALT}
            sizes={SHOT_SIZES}
            width={BILLING_SCREENSHOT.width}
            height={BILLING_SCREENSHOT.height}
          />
        ) : (
          <Frame>
            <div className="bar" aria-hidden="true">
              <i />
              <i />
              <i />
            </div>
            <div className="body">
              <MediaPlaceholder
                label="CloudPouch 2.0 Billing screenshot: services cost table with a service opened to its usage types"
                file="cloudpouch-2-billing-1600.webp"
                ratio="1600 / 1000"
              />
            </div>
          </Frame>
        )}
        <figcaption>
          The Billing view with the services cost table and usage-type
          drill-down.
        </figcaption>
      </Shot>
    </Container>
  </Wrapper>
);

export default InfoSection;
